<!-- 发布管理 -->
<template>
  <el-row :gutter="15">
    <el-col :span="24" :lg="6">
      <el-card class="wiki-part">
        <div class="clearfix mb-10">
          <div class="pull-right" style="width: 40px">
            <el-button
              class="d-iblock ma-0"
              type="primary"
              size="small"
              title="新建顶层目录分类"
              style="margin-left: 0"
              @click="onAddCatalogue"
            >
              <i class="fas fa-fw fa-plus" aria-hidden="true" />
            </el-button>
          </div>
          <div style="margin-right: 45px">
            <el-input
              v-model="filterText"
              placeholder="请输入关键字"
              style="width: 100%"
            ></el-input>
          </div>
        </div>

        <el-tree
          ref="catalogueTree"
          :data="catalogueList"
          :props="defaultProps"
          :filter-node-method="filterNode"
          :highlight-current="true"
          :expand-on-click-node="false"
          :default-expanded-keys="expandedKeys"
          :current-node-key="currentKey"
          :render-content="onRenderContent"
          class="filter-tree"
          node-key="ID"
          @node-click="clickNode"
        ></el-tree>
      </el-card>
    </el-col>

    <el-col :span="24" :lg="18">
      <el-card>
        <item-form :value="catalogueActiveData" v-if="showPublishWiki" />
        <item-detail
          :businessGroup="catalogueActiveData.BusinessGroup"
          :wikiID="catalogueActiveData.WikiID"
          :indexName="indexName"
          v-if="showWiki"
        />
        <div v-if="showUrl">
          <iframe
            style="width: 100%; height: 650px"
            :src="catalogueActiveData.Url"
            allowfullscreen="allowfullscreen"
            frameborder="0"
            data-id="1"
          ></iframe>
        </div>
      </el-card>
    </el-col>

    <el-dialog
      :title="(catalogueData.ID ? '编辑' : '新建') + '目录分类'"
      :visible.sync="catalogueVisible"
      :close-on-click-modal="false"
      width="600px"
      top="5vh"
      @open="onOpen"
      @close="onClose"
    >
      <el-form
        ref="catalogueDataForm"
        :model="catalogueData"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="上级名称" prop="ParentID">
          <!--当前点击的就是默认新建了上级名称-->
          <el-select
            v-model="catalogueData.ParentID"
            :clearable="false"
            placeholder="请选择上级"
            style="width: 100%"
          >
            <el-option
              v-for="(c, index) in catalogueSelectList"
              :key="index"
              :label="c.Title"
              :value="c.ID"
              :style="{ marginLeft: 15 * c.space + 'px' }"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目录名称" prop="Title">
          <el-input
            v-model.trim="catalogueData.Title"
            placeholder="请输入目录名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否发布" prop="isPublish">
          <el-switch v-model="isPublish"></el-switch>
        </el-form-item>
        <el-form-item label="文章类型" prop="PublishType">
          <el-radio-group v-model="catalogueData.PublishType">
            <el-radio :label="0">自定义</el-radio>
            <el-radio :label="1">关联知识库</el-radio>
            <el-radio :label="2">链接网页</el-radio>
            <el-radio :label="3" v-if="group === 0">程序版本</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="文章分类"
          prop="WikicatID"
          v-if="catalogueData.PublishType === 1"
        >
          <el-select
            v-model="WikicatID"
            :clearable="false"
            filterable
            placeholder="请选择文章分类"
            style="width: 100%"
          >
            <el-option
              v-for="(c, index) in wikicatSelectList"
              :key="index"
              :label="c.Title"
              :value="c.ID"
              :style="{ marginLeft: 15 * c.space + 'px' }"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="catalogueData.PublishType === 1"
          label="文章名称"
          prop="WikiID"
        >
          <select2
            style="width: 100%"
            labelName="Title"
            ref="selwiki"
            v-model="catalogueData.WikiID"
            :url="wikiUrl"
            :urlParams="{
              where: {},
            }"
            :clearable="false"
            placeholder="请选择文章名称"
            :disabled="!WikicatID"
            no-data-text="无文章"
            :currentList="curWikiID"
          ></select2>
        </el-form-item>
        <el-form-item
          label="网页地址"
          prop="Url"
          v-if="catalogueData.PublishType === 2"
        >
          <el-input
            v-model.trim="catalogueData.Url"
            :autosize="{ minRows: 2 }"
            type="textarea"
            placeholder="请输入网页地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序值" prop="Sort">
          <el-input-number
            v-model="catalogueData.Sort"
            :min="0"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div class="text-muted">注：上级名称为0则视为根目录。</div>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-if="catalogueData.ID"
          class="pull-left"
          type="danger"
          @click="removeCatalogue(catalogueData)"
        >
          <i class="fas fa-fw fa-trash"></i> 删 除
        </el-button>
        <el-button @click="catalogueVisible = false">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button
          :disabled="catalogueSubmitDisable"
          type="primary"
          @click="operateCatalogue"
        >
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
import ItemForm from "./index--form.vue";
import ItemDetail from "./view-detail.vue";

export default {
  components: {
    ItemForm,
    ItemDetail,
  },
  data() {
    return {
      group: 0, //业务组类型 0.嵌入式 1.工控
      //===================左边树===================
      isParent: false, // 是不是父级的目录
      catalogueVisible: false, //显示新增/编辑目录弹框
      catalogueData: this.getEmptyCatalogue(), //目录信息
      filterText: "", //检索目录
      catalogueList: [], //树的数据源，只有根节点，子节点在根节点children中
      defaultProps: {
        label: "Title",
        children: "Children",
      },
      expandedKeys: [], //id
      currentKey: "",
      catalogueActiveData: {}, //当前选中的节点信息
      lastKeyHighlight: "", // 最终要高亮的值，以前高亮之后再拉数据没有关系，现在不行了，只能先拉数据再高亮
      catalogueSubmitDisable: false,
      catalogueSelectList: [], //目录选择列表，所有节点列表
      spanceNum: 0,
      rules: {
        Title: [
          {
            required: true,
            message: "目录名称不能为空",
            trigger: "blur",
          },
          {
            max: 200,
            message: "目录名称不能超过200个字符",
            trigger: "blur",
          },
        ],
        PublishType: [
          {
            required: true,
            message: "发布类型不能为空",
            trigger: "blur",
          },
        ],
        // WikicatID: [
        //   {
        //     required: true,
        //     message: "文章分类不能为空",
        //     trigger: "blur",
        //   },
        // ],
        WikiID: [
          { required: true, message: "文章名称不能为空", trigger: "blur" },
        ],
        Url: [
          {
            required: true,
            message: "网页地址不能为空",
            trigger: "blur",
          },
        ],
        Sort: [{ required: true, message: "排序值不能为空", trigger: "blur" }],
      },
      treePager: {
        total: 0,
        page: 1,
        size: -1,
      },
      isPublish: false,
      wikicatSelectList: [], //知识库文章分类选择列表
      WikicatID: "",
      wikiUrl: "",
      curWikiID: [],
      requestRegObj: {
        reg: /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/, // eslint-disable-line
        msg: "URL格式不正确",
      },
      indexName: "",
      //===================右边部分===================
      showPublishWiki: false,
      showWiki: false,
      showUrl: false,
    };
  },
  created() {
    this.group = this.$route.meta.group;
    this.getCatalogueTree();
    this.getWikicatTree();
  },
  watch: {
    filterText: {
      handler() {
        // this.$refs.catalogueTree.filter(val);
        this.catalogueSelectList = [];
        this.catalogueList = [];
        this.catalogueActiveData = {};
        this.getCatalogueTree();
      },
    },
    WikicatID: {
      handler() {
        this.wikiUrl =
          this.group === 0
            ? `dci/wiki/publish?where[WikicatID]=${this.WikicatID}&where[Status]=2&order=-published_at`
            : `ipc/wiki/publish?where[WikicatID]=${this.WikicatID}&where[Status]=2&order=-published_at`;
      },
    },
    "catalogueData.WikiID": {
      handler() {
        if (
          this.catalogueData.WikiID !== 0 &&
          this.catalogueData.WikiID !== ""
        ) {
          this.$refs.selwiki.$data.optionList.forEach((obj) => {
            if (obj.ID === this.catalogueData.WikiID) {
              this.catalogueData.Title = obj.Title;
            }
          });
        }
      },
    },
  },
  mounted() {},
  methods: {
    //===================左边树===================
    //获取目录树
    getCatalogueTree() {
      this.catalogueSelectList = [];
      this.$axios
        .get(
          this.group === 0
            ? "dci/publishmanage/catalogue"
            : "ipc/publishmanage/catalogue",
          {
            params: {
              where: {
                BusinessGroup: this.group,
              },
              return_tree: 1,
              ...this.treePager,
              key: this.filterText,
              with: ["Parent", "PublishWiki", "Wiki.Wikicat"],
            },
          }
        )
        .then((response) => {
          response.data.forEach((ele) => {
            this.spanceNum = 0;
            this.getChild(ele);
          });
          this.catalogueList = response.data; //树数据源,只有根节点+children

          if (!this.catalogueActiveData.ID) {
            //树节点默认选中
            this.catalogueActiveData = response.data[0];

            this.bindRightContext();
            this.expandedKeys = [response.data[0].ID];
            this.lastKeyHighlight = response.data[0].ID;
          }
          this.setCurrentKeySelf(this.lastKeyHighlight);
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    // 递归获取,因为不知道children有多少层
    getChild(item) {
      const data = item;
      this.spanceNum = 0;
      this.getSpanceNum(data);
      data.space = this.spanceNum;
      if (!data.Children) {
        data.Children = [];
      }
      this.catalogueSelectList.push(data);
      data.Children.forEach((childItem) => {
        this.getChild(childItem);
      });
    },
    // 计算这个之前有多少个父结点，就要显示多少个空格
    getSpanceNum(item) {
      if (item.ParentID !== 0) {
        this.spanceNum++;
        this.getSpanceNum(
          this.catalogueSelectList[
            _.findIndex(this.catalogueSelectList, (c) => c.ID === item.ParentID)
          ]
        );
      }
    },

    //新建顶层目录
    onAddCatalogue() {
      this.isParent = true;
      this.catalogueData = this.getEmptyCatalogue();
      this.isPublish = false;
      this.WikicatID = "";
      this.curWikiID = [];
      this.catalogueVisible = true;
    },
    //清空目录信息
    getEmptyCatalogue() {
      return {
        Title: "", //目录名称
        ParentID: 0, //上级id
        Sort: 0, //排序
        PublishType: 0, //文章类型 0:自定义 1:关联知识库 2:链接网页 3.程序版本
        Status: 0, //状态 0:草稿.1:发布
        WikiID: "", //引用知识库文章id
        Url: "", //链接网页地址
        BusinessGroup: this.group, //业务组类型 0.嵌入式 1.工控
      };
    },
    // 对树节点进行筛选时执行的方法，返回 true 表示这个节点可以显示
    filterNode(value, data) {
      return data.Title.includes(value);
    },
    //点击树节点
    clickNode(data) {
      this.catalogueActiveData = data;
      this.expandedKeys = [data.ID];
      this.indexName = data.IndexName;
      this.bindRightContext();
    },
    onOpen() {},
    onClose() {
      this.catalogueVisible = false;
      this.catalogueSubmitDisable = false;
      this.$refs.catalogueDataForm.resetFields();
      this.catalogueData = this.getEmptyCatalogue();
      this.WikicatID = "";
      this.isPublish = false;
      this.curWikiID = [];
    },
    // 在节点中添加自定义内容，即添加，编辑，删除,功能按钮
    onRenderContent(h, { node, data }) {
      if (data.ID === 0) {
        //根节点
        return (
          <div class="show-node">
            <span>
              <span title={data.Title}>{data.Title}</span>
            </span>
          </div>
        );
      } else {
        if (data.Status === 1) {
          //发布
          return (
            <div class="show-node">
              <span>
                <span title={data.Title}>{data.Title}</span>
              </span>
              <span class="adjust-btn">
                {
                  <el-button
                    class="pr-10"
                    type="text"
                    title="添加"
                    onClick={(event) => this.onTypeCreate(event, data)}
                  >
                    <i class="fas fa-fw fa-plus"></i>
                  </el-button>
                }
                {
                  <el-button
                    type="text"
                    title="编辑"
                    onClick={(event) => this.onTypeEdit(node, event, data)}
                  >
                    <i class="fas fa-fw fa-edit"></i>
                  </el-button>
                }
              </span>
            </div>
          );
        } else {
          //未发布
          return (
            <div class="show-node">
              <span style="color:red;">
                <span title={data.Title}>
                  {data.Title}&nbsp;
                  <el-popover
                    placement="top-start"
                    width="250"
                    trigger="hover"
                    content=""
                  >
                    <div>未发布</div>
                    <i slot="reference" class="el-icon-info"></i>
                  </el-popover>
                </span>
              </span>
              <span class="adjust-btn">
                {
                  <el-button
                    class="pr-10"
                    type="text"
                    title="添加"
                    onClick={(event) => this.onTypeCreate(event, data)}
                  >
                    <i class="fas fa-fw fa-plus"></i>
                  </el-button>
                }
                {
                  <el-button
                    type="text"
                    title="编辑"
                    onClick={(event) => this.onTypeEdit(node, event, data)}
                  >
                    <i class="fas fa-fw fa-edit"></i>
                  </el-button>
                }
              </span>
            </div>
          );
        }
      }
    },
    // 添加父/子级分类
    onTypeCreate(event, data) {
      if (event) {
        // 阻止事件冒泡
        event.stopPropagation();
      }

      this.catalogueData = this.getEmptyCatalogue();
      this.WikicatID = "";
      this.isPublish = false;
      this.curWikiID = [];
      // 如果有值，表示添加的不是父级的分类
      if (data) {
        this.isParent = false;
        this.catalogueData.ParentID = data.ID;
        this.catalogueActiveData = data;

        if (this.catalogueActiveData.PublishType === 3) {
            this.$message({
              type: "warning",
              message: `程序版本节点下不能新增子节点`,
            });
            return;
        }
      } else {
        this.isParent = true;
      }
      // this.catalogueData.BusinessGroup = this.group;
      this.lastKeyHighlight = data.ID;
      this.catalogueVisible = true;
    },
    // 编辑分类
    onTypeEdit(node, event, data) {
      if (event) {
        // 阻止事件冒泡
        event.stopPropagation();
      }
      // 当前节点点击数据
      this.catalogueData = { ...data };
      // 如果不是Null，表示添加的不是父级的分类
      if (data.ParentID !== 0) {
        this.isParent = false;
      } else {
        this.isParent = true;
      }
      this.catalogueActiveData = data;
      this.catalogueVisible = true;

      this.isPublish = this.catalogueData.Status === 1 ? true : false;
      this.curWikiID = [];
      if (this.catalogueData.Wiki !== null) {
        this.WikicatID = this.catalogueData.Wiki.WikicatID;
        this.curWikiID = [
          {
            ID: this.catalogueData.Wiki.ID,
            Title: this.catalogueData.Wiki.Title,
          },
        ];
      } else {
        this.catalogueData.WikiID = "";
      }
    },
    // 删除分类
    removeCatalogue(data) {
      this.$confirm("是否删除该目录分类？", "请确定", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() =>
          this.$axios.delete(
            this.group === 0
              ? `dci/publishmanage/catalogue/${data.ID}`
              : `ipc/publishmanage/catalogue/${data.ID}`
          )
        )
        .then(() => {
          this.catalogueVisible = false;
          this.catalogueActiveData = {};
          this.$message.success("删除成功");
          this.getCatalogueTree();
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    // 分类的新增和编辑操作
    operateCatalogue() {
      this.$refs.catalogueDataForm.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.catalogueData.PublishType === 2) {
          if (!this.requestRegObj.reg.test(this.catalogueData.Url)) {
            this.$message({
              type: "warning",
              message: `网页地址格式不正确`,
            });
            return;
          }
        } else if (this.catalogueData.PublishType === 3) {
          //只有叶节点才能选择程序版本
          if (
            this.catalogueData.ID &&
            this.catalogueData.Children &&
            this.catalogueData.Children.length > 0
          ) {
            this.$message({
              type: "warning",
              message: `程序版本节点下不能有子节点`,
            });
            return;
          }
        }
        this.catalogueSubmitDisable = true;

        this.catalogueData.WikiID =
          this.catalogueData.WikiID === "" ? 0 : this.catalogueData.WikiID;

        this.catalogueData.Status = this.isPublish ? 1 : 0; //状态 0:草稿.1:发布
        this.$axios
          .request({
            url: this.catalogueData.ID
              ? this.group === 0
                ? `dci/publishmanage/catalogue/${this.catalogueData.ID}`
                : `ipc/publishmanage/catalogue/${this.catalogueData.ID}`
              : this.group === 0
              ? "dci/publishmanage/catalogue"
              : "ipc/publishmanage/catalogue",
            method: this.catalogueData.ID ? "put" : "post",
            data: this.catalogueData,
          })
          .then(() => {
            this.$message.success(
              this.catalogueData.ID ? "成功更新目录分类" : "成功新增目录分类"
            );
            this.getCatalogueTree();
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
          })
          .finally(() => {
            this.catalogueVisible = false;
            this.catalogueSubmitDisable = false;
          });
      });
    },
    // 手动设置currentKey
    setCurrentKeySelf(data) {
      this.$nextTick(() => {
        this.$refs.catalogueTree.setCurrentKey(data);
      });
    },

    //获取文章分类树
    getWikicatTree() {
      this.wikicatSelectList = [];
      this.$axios
        .get(this.group === 0 ? "dci/wikicat/publish" : "ipc/wikicat/publish", {
          params: {
            where: {
              BusinessGroup: this.group,
            },
            return_tree: 1,
            ...this.treePager,
          },
        })
        .then((response) => {
          response.data.forEach((ele) => {
            this.spanceNum = 0;
            this.getWikicatChild(ele);
          });
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    // 递归获取,因为不知道children有多少层
    getWikicatChild(item) {
      const data = item;
      this.spanceNum = 0;
      this.getWikicatSpanceNum(data);
      data.space = this.spanceNum;
      if (!data.Children) {
        data.Children = [];
      }
      this.wikicatSelectList.push(data);
      data.Children.forEach((childItem) => {
        this.getWikicatChild(childItem);
      });
    },
    // 计算这个之前有多少个父结点，就要显示多少个空格
    getWikicatSpanceNum(item) {
      if (item.ParentID !== 0) {
        this.spanceNum++;
        this.getSpanceNum(
          this.wikicatSelectList[
            _.findIndex(this.wikicatSelectList, (c) => c.ID === item.ParentID)
          ]
        );
      }
    },
    //===================右边部分===================
    bindRightContext() {
      // 移除组件
      this.showPublishWiki = false;
      this.showWiki = false;
      this.showUrl = false;

      //文章类型 0:自定义 1:关联知识库 2:链接网页 3.程序版本
      if (this.catalogueActiveData.PublishType === 0) {
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this.$nextTick(() => {
          this.showPublishWiki = true;
        });
      } else if (this.catalogueActiveData.PublishType === 1) {
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this.$nextTick(() => {
          this.showWiki = true;
        });
      } else if (this.catalogueActiveData.PublishType === 2) {
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this.$nextTick(() => {
          this.showUrl = true;
        });
      }
    },
  },
};
</script>

<style lang="scss">
.wiki-part {
  .el-tree-node__content {
    position: relative;
  }
  .show-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 8px;
    font-size: 14px;
    padding-top: 5px;
  }
  .adjust-btn {
    display: none;
    position: absolute;
    right: 15px;
  }
  .show-node:hover .adjust-btn {
    display: block;
  }
  .adjust-btn .el-button {
    margin: 0;
  }
}
.d-iblock {
  display: inline-block;
}
.standard-search {
  margin-right: 0.5em;
  .el-select {
    .el-input .el-input__inner {
      height: 28px !important;
    }
    .el-select__tags,
    .el-select__tags span {
      white-space: nowrap;
      overflow: hidden;
      flex-wrap: nowrap;
    }
  }
  vertical-align: middle;
}
</style>
